import { render, staticRenderFns } from "./ClientCPAssessment.vue?vue&type=template&id=7a9bc01e&scoped=true&"
import script from "./ClientCPAssessment.vue?vue&type=script&lang=js&"
export * from "./ClientCPAssessment.vue?vue&type=script&lang=js&"
import style0 from "./ClientCPAssessment.vue?vue&type=style&index=0&id=7a9bc01e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a9bc01e",
  null
  
)

export default component.exports